<template>
    <div
        v-if="user !== null"
        class="container"
    >
        <div class="titleWrapper">
            <p class="subtitleItem px-5">Register</p>
            <h2 class="titleItem">新規会員登録</h2> 
        </div>
        <div class="card">
            <div class="card-body">
                <user-signup-step state="first_update"/>
                <div class="form-group row mt-3">
                    <div class="main-title">
                        <h3>初回ログイン</h3>
                        <p>下記の項目を入力し、初回ログインを完了してください。</p>
                    </div>
                    <div class="col-12">    
                        <div class="pb-3">
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-8 mb-4">
                                    <label
                                        for="last_name_kana"
                                    >
                                        お名前
                                        <img
                                            src="/images/icon_required.png"
                                            alt="必須マーク"
                                            style="height: 1em"
                                        />
                                    </label>                                
                                    <div class="d-flex" style="gap: 16px;">
                                        <div class="flex-fill">
                                            <input
                                                v-model="user.last_name"
                                                type="text"
                                                id="last_name_kana"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.last_name }"
                                                placeholder="性">
                                            <div
                                                v-if="errors.last_name"
                                                class="invalid-feedback d-block">
                                                {{ errors.last_name[0] }}
                                            </div>                                            
                                        </div>
                                        <div class="flex-fill">
                                            <input
                                                v-model="user.first_name"
                                                type="text"
                                                id="first_name_kana"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.first_name }"
                                                placeholder="名">
                                            <div
                                                v-if="errors.first_name"
                                                class="invalid-feedback d-block">
                                                {{ errors.first_name[0] }}
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">
                                <div class="col-12 col-md-8 mb-4">
                                    <label
                                        for="last_name_kana">
                                        フリガナ
                                        <img
                                            src="/images/icon_required.png"
                                            alt="必須マーク"
                                            style="height: 1em"
                                        />
                                    </label>
                                    <div class="d-flex" style="gap: 16px;">
                                        <div class="flex-fill">
                                            <input
                                                v-model="user.last_name_kana"
                                                type="text"
                                                id="last_name_kana"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.last_name_kana }"
                                                placeholder="セイ">
                                            <div
                                                v-if="errors.last_name_kana"
                                                class="invalid-feedback d-block">
                                                {{ errors.last_name_kana[0] }}
                                            </div>                                            
                                        </div>
                                        <div class="flex-fill">
                                            <input
                                                v-model="user.first_name_kana"
                                                type="text"
                                                id="first_name_kana"
                                                class="form-control"
                                                :class="{ 'is-invalid' : errors.first_name_kana }"
                                                placeholder="メイ">
                                            <div
                                                v-if="errors.first_name_kana"
                                                class="invalid-feedback d-block">
                                                {{ errors.first_name_kana[0] }}
                                            </div>                                                
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">
                                <div class="col-12 col-md-8 mb-4 mx-auto">
                                    <label for="birth_year">
                                    生年月日
                                    <img
                                        src="/images/icon_required.png"
                                        alt="必須マーク"
                                        style="height: 1em"
                                    />
                                    </label>
                                    <div class="d-flex align-items-center">
                                    <div class="custom-select-wrapper flex-fill">
                                    <select
                                        v-model="birth_year"
                                        id="birth_year"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }">
                                        <option :value="null">-</option>
                                        <option v-for="n in rangeYear" :key="n + yearBase" :value="n + yearBase">{{ n + yearBase }}</option>
                                    </select>
                                    </div>

                                    <div class="ml-2 mr-2">年</div>

                                    <div class="custom-select-wrapper flex-fill">
                                    <select
                                        v-model="birth_month"
                                        id="birth_month"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }">
                                        <option :value="null">-</option>
                                        <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    </div>

                                    <div class="ml-2 mr-2">月</div>

                                    <div class="custom-select-wrapper flex-fill">
                                    <select
                                        v-model="birth_day"
                                        id="birth_day"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }">
                                        <option :value="null">-</option>
                                        <option v-for="n in rangeDate" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    </div>

                                    <div class="ml-2">日</div>

                                    </div>
                                    <div
                                        v-if="errors.birthday"
                                        class="invalid-feedback d-block">
                                        {{ errors.birthday[0] }}
                                    </div>
                                </div>

                                <div class="col-md-8 mb-2 mx-auto">
                                    <label>
                                    性別
                                    <img
                                        src="/images/icon_required.png"
                                        alt="必須マーク"
                                        style="height: 1em"
                                    />
                                    </label>
                                    <div class="form-group mt-2">
                                        <div class="form-check form-check-inline mr-4 ml-2">
                                            <input
                                                v-model="user.sex"
                                                type="radio"
                                                id="male"
                                                class="form-check-input custom-radio"
                                                :class="{ 'is-invalid' : errors.sex }"
                                                value="0">
                                            <label class="form-check-label" for="male">男</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input
                                                v-model="user.sex"
                                                type="radio"
                                                id="female"
                                                class="form-check-input custom-radio"
                                                :class="{ 'is-invalid' : errors.sex }"
                                                value="1">
                                            <label class="form-check-label" for="female">女</label>
                                        </div>
                                        <div
                                            v-if="errors.sex"
                                            class="invalid-feedback d-block">
                                            {{ errors.sex[0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">
                                <div class="col-md-8 mb-4 mx-auto">
                                    <label
                                        for="address">
                                        居住区
                                        <img
                                            src="/images/icon_required.png"
                                            alt="必須マーク"
                                            style="height: 1em"
                                        />
                                    </label>
                                    <input
                                        v-model="user.address"
                                        type="text"
                                        id="address"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.address }"
                                        placeholder="アメリカ、カナダなど">
                                    <div
                                        v-if="errors.address"
                                        class="invalid-feedback d-block">
                                        {{ errors.address[0] }}
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="$store.state.configs.timezone == 1"
                                class="row justify-content-center">
                                <div class="col-md-8 mb-3 mx-auto">
                                    <label
                                        for="timezone">
                                        タイムゾーン設定
                                        <img
                                            src="/images/icon_required.png"
                                            alt="必須マーク"
                                            style="height: 1em"
                                        />
                                    </label>
                                    <div class="form-group mt-0 mb-1">
                                        <div class="form-check form-check-inline custom-check">
                                            <input
                                                v-model="user.is_device_timezone"
                                                type="checkbox"
                                                id="is_device_timezone"
                                                class="form-check-input"
                                                @change="syncDeviceTimezone"
                                            >
                                            <label for="is_device_timezone" class="form-check-label mb-0">
                                                デバイスのタイムゾーンに合わせる
                                            </label>
                                        </div>
                                    </div>
                                    <div class="custom-select-wrapper">
                                    <select
                                        v-model="user.timezone"
                                        :disabled="user.is_device_timezone == 1"
                                        id="timezone"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.timezone }"
                                    >
                                        <option value="">選択してください</option>
                                        <option v-for="timezone in timezones" :value="timezone.key">
                                        {{ timezone.value }}
                                        </option>
                                    </select>
                                    </div>

                                    <span class="mt-1 small text-muted">日本との時差を自動調節するため、オンライン相談時に滞在している国のタイムゾーンを選択してください。</span>

                                    <div v-if="errors.timezone" class="invalid-feedback d-block">
                                        {{ errors.timezone[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                    <button
                        class="btn btn-yokumiru-orange btn-custmize"
                        :disabled="inProgress"
                        @click="update">
                        会員登録する
                    </button>
                </div>
            </div>
        </div>

        <user-coupons-notification-modal
            :user="dataUser"
            :user-coupons="newUserCoupons"
            is-first-setup>
        </user-coupons-notification-modal>

        <how-to-use-coupon-modal/>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import { mapMutations } from 'vuex'

    export default {
        props: {
            dataUser: {
                type: Object,
                default: {},
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                user: null,
                prevTimezone: null,
                birth_year: null,
                birth_month: null,
                birth_day: null,
                yearBase: 1899,
                yearTo: moment().year(),
                errors: {},
                inProgress: false,
                timezones: [],
                newUserCoupons: [],
            };
        },

        computed: {
            rangeYear: function () {
                return this.yearTo - this.yearBase
            },

            rangeDate: function () {
                const year = this.birth_year ? this.birth_year.toString() : '1900'
                const month = this.birth_month ? this.birth_month.toString().padStart(2, '0') : '01'

                return moment(`${year}-${month}-01`).endOf('month').date()
            },
        },

        created: async function () {
            this.user = { ...this.dataUser }

            if (this.user.is_admin_registration) {
                if (this.user.birthday) {
                    this.birth_year = Number(this.user.birthday.slice(0,4))
                    this.birth_month = Number(this.user.birthday.slice(5,7))
                    this.birth_day = Number(this.user.birthday.slice(8,10))
                }
            }
            else {
                this.user.sex = null
            }

            if (this.$store.state.configs.timezone == 1) {
                await this.fetchTimezones()
                this.syncDeviceTimezone()
            }
        },

        mounted: function () {
            // メールアドレス認証結果のアラート
            if (this.$route.query.verified === '1') {
                bus.$emit('alert-success', 'メールアドレスを認証しました。')
            }

            // サブスクリプション開始後アラート
            if (this.$store.state.userMode.isAgreedTerms) {
                this.setIsAgreedTerms(false)
                bus.$emit('alert-info', '利用規約に同意しました。')
            }
        },

        methods: {
            ...mapMutations({
                setIsAgreedTerms: 'userMode/setIsAgreedTerms',
                setIsResetPassword: 'userMode/setIsResetPassword',
            }),

            syncDeviceTimezone: function () {
                if (this.user.is_device_timezone == 1) {
                    this.prevTimezone = this.user.timezone
                    const browserZone = moment.tz.guess()

                    this.timezones.forEach((timezone) => {
                        if (timezone.key === browserZone) {
                            this.user.timezone = browserZone
                        }
                    })
                }
                else if (this.prevTimezone) {
                    this.user.timezone = this.prevTimezone
                }
            },

            /**
             * タイムゾーン取得
             *
             * @returns {Promise<void>}
             */
            fetchTimezones: async function () {
                return axios.get(constants.user.profile.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })

                const browserZone = moment.tz.guess()

                this.timezones.forEach((timezone) => {
                    if (timezone.key === browserZone) {
                        this.user.timezone = browserZone
                    }
                })
            },

            /**
             * 初回ログイン情報更新
             */
            update: async function() {
                if (this.inProgress) return
                this.inProgress = true

                let birthday = null

                if (this.birth_year && this.birth_month && this.birth_day) {
                    birthday = this.birth_year.toString() + '-' +
                        this.birth_month.toString().padStart(2, '0') + '-' +
                        this.birth_day.toString().padStart(2, '0')
                }

                const data = {
                    last_name: this.user.last_name,
                    first_name: this.user.first_name,
                    last_name_kana: this.user.last_name_kana,
                    first_name_kana: this.user.first_name_kana,
                    birthday: birthday,
                    sex: this.user.sex,
                    address: this.user.address,
                }

                if (this.$store.state.configs.timezone == 1) {
                    data['timezone'] = this.user.timezone
                    data['is_device_timezone'] = this.user.is_device_timezone
                }

                await axios.put(`${constants.user.me.endpoint.base}/first/consul`, data)
                    .then(() => {
                        this.setIsResetPassword(true)

                        if (!this.user.user_metadata.is_formrun) {
                            window.location.href = '/formrun'
                        }
                        else {
                            window.location.href = '/home'
                        }
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }

                        this.inProgress = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
.container {
    max-width: 950px;
    padding: 0 30px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width:767px) {
        padding: 0 15px;
    }
}

.titleWrapper {
    margin-bottom: 16px;
    text-align: center;
    .subtitleItem {
        margin-bottom: 5px;
        background-color: #F77795;
        color: white;
        border-radius: 10px;
        display: inline-block;
    }
    .titleItem {
        color: #2A2E31;
        font-size: 23px;
        font-weight: bold;
    }
}
.vc-register-title {
  margin-bottom: 25px;
  color: #434343;

  span {
    display: block;

    &:nth-child(1) {
      font-size: 19px;
    }

    &:nth-child(2) {
      font-size: 24px;
      font-weight: bold;
    }
  }
}

.vc-campaign {
  text-align: center;

  .vc-campaign__meta {
    .vc-campaign__meta-title {
      color: #e91f63;
      font-size: 26px;
      text-align: center;
    }

    .vc-campaign__meta-description {
      color: #333;
    }
  }
}
.main-title{
    text-align: center;
    margin:24px auto 0;
    h3{
        font-size: 18px;
        padding-bottom: 10px;
        font-weight: bold;
    }
    @media screen and (max-width:640px) {
        display: none;
    }
}
.card {
    box-shadow: 0px 4px 12px 0px #00000026;
    border-radius: 0;
    border: none;
    max-width: 950px;
    margin: 0 auto;
}

.card-body {
    padding: 30px 62px;

    @media screen and (max-width:767px) {
        padding: 15px;
    }
}

.vc-plan {
    max-width: 600px;

    .card {
        background-color: #f6f8fa;
    }

    .vc-plan__title {
        font-size: 1rem;
    }

    .vc-plan__detail {
        border-bottom: 1px solid #dee2e6;
    }
}
.custom-select-wrapper {
  position: relative;
}

.custom-select-wrapper::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 1em;
  width: 0.5em;
  height: 0.5em;
  border-right: 2px solid #333;
  border-bottom: 2px solid #333;
  transform: translateY(-50%) rotate(45deg);
  pointer-events: none;
}

.custom-select-wrapper select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  padding-right: 2em;
}

.custom-radio {
  transform: scale(1.3);
  appearance: none;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: white;
  position: relative;
  margin-right: 8px;
  cursor: pointer;
  vertical-align: middle;
}

/* チェック時に中央に青丸 */
.custom-radio:checked::before {
  content: '';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 10px;
  height: 10px;
  background-color: #00a9b7;
  border-radius: 50%;
}

.custom-check .form-check-input {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-top: 0;
  margin-right: 8px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  position: relative;
}
.custom-select-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

/* カスタム矢印 */
.custom-select-wrapper::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 1em;
  width: 0.5em;
  height: 0.5em;
  border-right: 2px solid #00a9b7;
  border-bottom: 2px solid #00a9b7;
  transform: translateY(-50%) rotate(45deg);
  pointer-events: none;
}

/* セレクトからデフォルト矢印を消す */
.custom-select-wrapper select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
  padding-right: 2.5em;
}

/* チェックされた状態の背景とアイコン風 */
.custom-check .form-check-input:checked {
  background-color: white;
}

.custom-check .form-check-input:checked::after {
  content: '';
  position: absolute;
  left: 8px;
  top: 2px;
  width: 8px;
  height: 14px;
  border: solid #00a9b7;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.custom-select-wrapper select:disabled {
  background-color: #e0e0e0; /* 薄いグレー */
  color: #6c757d; /* Bootstrapのdisabled文字色 */
  cursor: not-allowed;
}

.custom-select-wrapper select:enabled {
  background-color: #fff;
  color: #212529;
}
.btn-custmize{
    padding: 10px 80px;
    font-size: 16px;
    margin-bottom: 24px;

}
</style>
